module.exports = __webpack_public_path__ + "sitemap.xml";


//////////////////
// WEBPACK FOOTER
// ./src/sitemap.xml
// module id = 465
// module chunks = 0